import { observer } from 'mobx-react';
import { FC, useCallback, useEffect } from 'react';
import { NotificationsSettingType } from '../../constants/notifications';
import NotificationsSettingList from '../../containers/NotificationsSettingList/NotificationsSettingList';
import NotificationsSettingNavigation from '../../containers/NotificationsSettingNavigation/NotificationsSettingNavigation';
import { walletNotificationsStore } from './store';
import { SCREENS } from 'src/constants/screens';
import { localeStore } from 'src/mobx/localesStore';
import { history } from 'src/services/history';
import Button from 'src/view/components/Controls/ButtonComponent/Button';

const WalletNotificationsScreen: FC = observer((): JSX.Element => {
  useEffect(() => {
    return () => walletNotificationsStore.clearFilters();
  }, []);

  const onCreate = useCallback(() => {
    history.push(SCREENS.SETTINGS_NOTIFICATIONS_WALLET_CREATE());
  }, []);

  return (
    <div className="d-flex flex-column flex-1">
      <NotificationsSettingNavigation />

      <div className="d-flex flex-row justify-content-end mr-4">
        <Button title={localeStore.t('create_notification')} onClick={onCreate} />
      </div>

      <NotificationsSettingList
        type={NotificationsSettingType.WALLET}
        loading={walletNotificationsStore.loading}
        isLoading={walletNotificationsStore.isLoading}
        pagination={walletNotificationsStore.pagination}
        filters={walletNotificationsStore.filters}
        fetchNotifications={walletNotificationsStore.fetchNotifications}
        setFilters={walletNotificationsStore.setFilters}
        onStatusChange={walletNotificationsStore.changeNotificationStatus}
        onDelete={walletNotificationsStore.deleteNotification}
      />
    </div>
  );
});

export default WalletNotificationsScreen;
